<template>
  <div>
  <myHeader></myHeader>

    <div class="webTarifHomme webTarifMainBloc">
      <h2>Hommes</h2>
      <div class="webTarifImg webTarifImg2">
        <img src="../../assets/PrestationHomme2.jpeg" alt="coupe homme">
      </div>
      <p class="webTarifTitle">Un moment pour vous, Messieurs</p>

      <h3 class="webTarifH3Style">Tarifs</h3>
      <div class="webTarifgroup">
        <div class="webTarifEntete">
          <p class="webTarifLines"></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
          <p></p>
        </div>
        <div :key="'tarifFiltersMen' + index" v-for="(tarifFiltersMen, index) in tarifFiltersMen">
          <p @click.prevent="editTarif(tarifFiltersMen._id)" type="submit" class="webTarifNames">{{ tarifFiltersMen.name }}
          </p>
          <div class="webTarifLines">
            <p class="webTarifValues"></p>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersMen.priceS" type="string" name="priceS" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersMen.priceM" type="string" name="priceM" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersMen.priceUnique" type="string" name="priceUnique" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersMen.priceL" type="string" name="priceL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
            <vue-numeric currency="€" currency-symbol-position="suffix" v-bind:precision="2"
              v-model="tarifFiltersMen.priceXL" type="string" name="priceXL" class="webTarifValues"
              disabled="disabled"></vue-numeric>
          </div>
        </div>
      </div>

      <div class="webTarifComplements">
        <p class="webTarifNames webTarifJustify"> Des réductions sur groupes sont applicables, sous conditions (sur toutes
        les prestations adultes) :</p>
      <p class="webTarifNames webTarifReductions">2 personnes : - 5%</p>
      <p class="webTarifNames webTarifReductions">3 personnes : - 10%</p>
      <p class="webTarifNames webTarifReductions">4 personnes : - 15%</p>
      <p class="webTarifNames webTarifReductions">5 personnes et + : - 20%</p>
    </div>

  </div>
  <myFooter></myFooter>
  </div>
</template>

<script>
import axios from 'axios'
import VueNumeric from 'vue-numeric'
export default {
  components: {
    VueNumeric
  },
  name: 'webTarifMens',
  data () {
    return {
      tarif: []
    }
  },
  mounted () {
    this.getAllTarifs()
  },
  computed: {
    tarifFiltersMen () {
      return this.tarif.filter(tarif => tarif.category === 'HOMMES')
    }
  },
  methods: {
    getAllTarifs () {
      axios
        .get(('https://privilegia.fr/api/tarifs'))
        .then((response) => {
          this.tarif = response.data.sort(function tri (a, b) {
            if (a.name < b.name) { return -1 }
            if (a.name === b.name) { return 0 }
            if (a.name > b.name) { return 1 }
          })
        })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SiteWeb/WebTarifsHommes.vue